/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { getDevelopmentHeaders } from '../../../../helpers/request-helpers';
import { TransportMiddlewareProps, AuthInternalError } from '../../../../core';

import type { TransportMiddlewareContext, TransportMiddlewareRequest, TransportMiddlewareResponse, NextFunction } from '../../../../core';

export const processHeadersMiddleware = <T, R, E>(
    next: NextFunction<TransportMiddlewareResponse<R, E> | Error>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, E>
) => {
    const { config, commands, middlewareConfigs } = ctx;
    const { type, noAuth, requestInit } = req.options;
    const { processHeadersMiddleware } = middlewareConfigs;

    if (processHeadersMiddleware?.ignoreToken) {
        req.headers = {
            ...requestInit.headers,
            ...config.getBaseHeaders({ token: null, type }),
            ...(process.env.NODE_ENV === 'development' ? getDevelopmentHeaders() : {}),
        };
        next();
        return;
    }

    (noAuth ? Promise.resolve(null) : commands.getAuthToken())
        .then((token) => {
            if (!token && !noAuth) {
                res[TransportMiddlewareProps.ErrorResponse] = new AuthInternalError(req.url);
                next(res);
                return;
            }

            req.headers = {
                ...requestInit.headers,
                ...config.getBaseHeaders({ token, type }),
                ...(process.env.NODE_ENV === 'development' ? getDevelopmentHeaders() : {}),
            };
            next();
        });
};
